import React, { useEffect, useState, useRef } from 'react';
import partnerPointDetail2 from '../../assets/images/partner/partner_point_detail_2.png';
import partnerPointDetailCategory2 from '../../assets/images/partner/partner_point_detail_category_2.png';

function PartnerPoint2() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.05,
        rootMargin: '-50px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="w-full flex justify-center bg-[#340065] overflow-hidden min-h-[760px] md:min-h-[855px]">
      <div className="w-full pt-[100px] md:pt-[0px] flex flex-col-reverse md:flex-row items-center justify-between mx-4 md:mx-[60px] bg-[#FDF4FF]">
        {/* 왼쪽 이미지 영역 */}
        <div
          className={`w-full pb-[40px] md:pb-[0px] md:w-1/2 flex justify-center md:justify-end items-center mb-[5px] md:mb-0 mt-[5px] md:mt-0 transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="relative md:mr-[40px] w-[300px] md:w-[560px] h-[305px] md:h-[571px] flex justify-center md:justify-end items-center">
            <div className="w-full h-full flex justify-center md:justify-end">
              <img
                src={partnerPointDetail2}
                alt="폰피쉬 앱 화면"
                className="h-full object-contain drop-shadow-lg"
                style={{ width: 'auto' }}
              />
            </div>
          </div>
        </div>

        {/* 오른쪽 텍스트 영역 */}
        <div
          className={`w-full md:w-1/2 flex flex-col justify-center items-center md:items-start px-4 md:px-[120px] space-y-[16px] md:space-y-[60px] transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <img
            src={partnerPointDetailCategory2}
            alt="초기 비용 ZERO"
            className="w-[232px] h-[63px] md:w-[254px] md:h-[80px] object-contain"
          />

          <h2 className="font-pretendard font-bold text-[24px] md:text-[40px] leading-[140%] text-black text-center md:text-left">
            <span className="md:hidden">초기 투자 비용 0원,<br />재고 부담 없는<br />안정적인 수익 창출</span>
            <span className="hidden md:inline">초기 투자 비용 0원,<br />재고 부담 없는 안정적인 수익 창출</span>
          </h2>

          <p className="font-pretendard font-normal text-[16px] md:text-[22px] leading-[180%] text-black text-center md:text-left">
            ✅ 가입비 0원, 운영비 0원으로 바로 시작<br />
            💰 초기 투자 없이 수익만 쌓이는 판매 구조<br />
            📦 사업 · 재고 부담 없이 안정적인 판매 운영
          </p>
        </div>
      </div>
    </section>
  );
}

export default PartnerPoint2; 